<template>
  <div class="bg-white min-height">
    <div class="head">
      安丘专技教育
    </div>
    <div class="container text-center">
      <img class="app-logo" src="/static/img/index/logo-only.png"/>
    </div>
    <div id="weixin-tip" v-if="isShow">
      <p>
        <img id="img-tip" style="margin-left: 60px;margin-top: 50px;"
             src="/static/img/qrcode/android-tip.png"
             alt="点击右上角，使用浏览器打开"/>
        <span @click="isShow=false" id="close" title="关闭" class="close">×</span>
      </p>
    </div>
    <div class="info">如果您还没有安装安丘专技教育app，<br>请点击立即下载</div>
    <input type="button" id="btn" name="btn" class="btn_download" @click="fBrowserRedirect" value="立即下载"/>
  </div>
</template>

<script>
  export default {
    name: "appDown",
    data() {
      return {
        bForcepc: false,
        isShow: false,
        content: '',
        version: '',
      }
    },
    created() {
      this.checkAppInstalled();

    },
    mounted() {
      // this.bForcepc = this.fGetQuery("dv") == "pc";
      this.getContent();
    },
    methods: {
      //判断手机是否已经安装了app
      checkAppInstalled() {
        let type = this.$route.query['type'];
        let id = this.$route.query['id'];
        // let scheme;
        // // 自己的URL Scheme，问号后面是拼接的参数，安卓根据参数跳转不同的页面
        // //
        // if(type && id) {
        //   scheme =  'com.aqjsjx.app://' + '?type=' + type + '&id=' + id
        // }else {
        //   scheme =  'com.aqjsjx.app://aqjsjx'
        // }


        this.isShow = false;
        let sUserAgent = navigator.userAgent.toLowerCase();
        let isWX = sUserAgent.match(/micromessenger/i);
        let isQQ = sUserAgent.match(/qqbrowser/i);
        let isAlipay = sUserAgent.match(/alipay/i);
        let isAndroid = sUserAgent.match(/android/i);
        let isXiaomi = sUserAgent.match(/xiaomi/i);
        let isRedmi = sUserAgent.match(/redmi/i);
        let isIphoneOs = sUserAgent.match(/(iPhone|iPad);?/i);

        if (isWX || isQQ || isAlipay) {
          let winHeight = typeof window.innerHeight != 'undefined' ? window.innerHeight : document.documentElement.clientHeight;
          let imgTip = $('#img-tip');
          this.isShow = true;
          $('#weixin-tip').height(winHeight);

          if (isAndroid || isXiaomi || isRedmi) {
            imgTip.src = '/static/img/qrcode/android-tip.png';
          } else {
            imgTip.src = '/static/img/qrcode/ios-tip.png';
          }
        } else {
          if (isAndroid || isXiaomi || isRedmi) {
            this.isShow = false;
            window.location.href = 'com.aqjsjx.app://aqjsjx';
          } else if (isIphoneOs) {
            this.isShow = false;
            window.location.href = 'applinks:m.aqjsjx.com.cn';
          }
        }
      },
      getContent() {
        this.$store.dispatch('getAppversionAndroid', {categoryIds: 'appversion_android'}).then((res) => {
          this.version = res.appversion_android[0].title;
          this.content = res.appversion_android[0].content;
        })
      },
      fBrowserRedirect() {
        let iso_url = "https://itunes.apple.com/cn/app/id1566506863";
        let android_url = "https://res.aqjsjx.com.cn/" + this.content + '?filename=aqjsjx-' + this.version + '.apk';
        let sUserAgent = navigator.userAgent.toLowerCase();
        let isIphoneOs = sUserAgent.match(/(iPhone|iPad);?/i);
        let isAndroid = sUserAgent.match(/android/i);
        let isXiaomi = sUserAgent.match(/xiaomi/i);
        let isRedmi = sUserAgent.match(/redmi/i);
        if (isIphoneOs) {
          if (!this.bForcepc) {
            window.location.href = iso_url;
          }
        } else if (isAndroid) {
          $("#btn").attr("value", "正在后台下载");
          if (!this.bForcepc) {
            window.location.href = android_url;
          }
        } else if (isXiaomi || isRedmi) {
          //小米手机自己的扫码应用
          if (!this.bForcepc) {
            window.location.href = android_url;
          }
        } else {
          alert("十分抱歉，目前安丘专技教育App暂时只支持安卓手机和苹果手机！");
        }
      }
      //
      // fGetQuery(name) {//获取参数值
      //   let sUrl = window.location.search.substr(1);
      //   let r = sUrl.match(new RegExp("(^|&)" + name + "=([^&]*)(&|$)"));
      //   return (r == null ? null : unescape(r[2]));
      // }
    }
  }
</script>

<style>
  .head {
    width: 100%;
    height: 40px;
    background: #2474FF;
    line-height: 40px;
    vertical-align: middle;
    text-align: center;
    color: #FFFFFF;
  }

  #weixin-tip {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    filter: alpha(opacity=80);
    width: 100%;
    height: 100%;
    z-index: 100;
  }

  #weixin-tip p {
    text-align: center;
    margin-top: 10%;
    padding: 0 5%;
    position: relative;
  }

  #weixin-tip .close {
    color: #fff;
    padding: 5px;
    font: bold 20px/20px simsun;
    text-shadow: 0 1px 0 #ddd;
    position: absolute;
    top: 0;
    left: 5%;
  }

  .container .app-logo {
    width: 64px;
    margin: 50px auto 20px;
  }

  .info {
    line-height: 32px;
    vertical-align: middle;
    text-align: center;
  }

  .btn_download {
    width: 200px;
    height: 40px;
    display: block;
    margin: 50px auto 0;
    border: 1px solid #2474FF;
    background-color: #fff;
    font-size: 16px;
    color: #2474FF;
  }
</style>
